import { createContext, useContext } from 'react';

const SessionContext = createContext();

const useSession = () => useContext(SessionContext);

export { useSession };

export default SessionContext.Provider;
